webpackJsonp([261381953904780],{

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_React$Component) {
	  _inherits(Profile, _React$Component);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Profile.prototype.componentDidMount = function componentDidMount() {
	    if (typeof twttr != 'undefined') {
	      twttr.widgets.load(this.refs.twButton);
	    }
	  };
	
	  Profile.prototype.render = function render() {
	    var pathPrefix =  false ? '' : ("");
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement('img', {
	            src: pathPrefix + '/img/profile.jpg',
	            alt: 'trevtrich',
	            className: 'rounded-circle mx-auto d-block',
	            width: '120px'
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                ref: 'twButton',
	                href: 'https://twitter.com/trevtrich',
	                className: 'twitter-follow-button',
	                'data-show-count': 'false'
	              },
	              'Follow @trevtrich'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'experience', className: 'bg-primary text-white' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'section-heading' },
	                'EXPERIENCE'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Gain Compliance'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Currently focussing on front-end work with a React-Redux stack and a Hapi.js server as our back-end for front-end leveraging REST-based HATEOAS patterns as much as possible. Deploying continuously using Travis CI into Google\u2019s App Engine platform. Contributing to interface design and user experience of the product.'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'LevelView'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Designed, developed, and published iOS application in Swift as a utility application people can use for ensuring how "level" something is whether hanging photos on a wall or something similar.'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Source Allies'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Operated as software consultant and craftsman in an agile (scrum) environment. Leveraged a microservices architecture backed by technologies including Scala, Docker, Amazon Web Services, RESTful web services, FitNesse, and Jenkins.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'features', className: 'text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'section-heading' },
	                'SKILLS'
	              ),
	              _react2.default.createElement('hr', { className: 'border-white' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-md-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'JavaScript'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-javascript-plain wow bounceIn',
	                  'data-wow-duration': '2.0s'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'React.js'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-react-original wow bounceIn',
	                  'data-wow-duration': '2.0s'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'Node.js'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-nodejs-plain-wordmark wow bounceIn',
	                  'data-wow-duration': '2.0s'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-md-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'Java'
	                },
	                _react2.default.createElement('i', { className: 'devicon-java-plain', 'data-wow-duration': '2.0s' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'C++'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-cplusplus-plain',
	                  'data-wow-duration': '2.0s'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'Postgresql'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-postgresql-plain',
	                  'data-wow-duration': '2.0s'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'AWS'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-amazonwebservices-plain-wordmark',
	                  'data-wow-duration': '2.0s'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-md-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'service-box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'Vim'
	                },
	                _react2.default.createElement('i', { className: 'devicon-vim-plain', 'data-wow-duration': '2.0s' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'education', className: 'bg-primary text-white' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'section-heading' },
	                'Education'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'M.S. Co-Major Human Computer Interaction & Computer Engineering, Iowa State University, 3.94 GPA'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'B.S. Mechanical Engineering, Iowa State University, 3.72 GPA'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Profile;
	}(_react2.default.Component);
	
	exports.default = Profile;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-profile-index-jsx-03b222419e7315573b49.js